module.exports = __webpack_public_path__ + "static/media/vivest.68e7ba7d.jpg";